import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Piles(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-010-piles-page"}>
            <div className="pageWrapper">
                <DetailHeader diseaseName={"Piles"}></DetailHeader>
                <div className="MainContent">
                    <div className="container">
                        <div className="page-rte">
                            <p>
                                Haemorrhoids (piles) are <b>enlarged blood vessels that you can
                                get inside or around your anus</b> (the opening of your bottom). It's
                                completely normal to have blood vessels in your anus, as they
                                play an important role in continence. But piles can develop if
                                these blood vessels become enlarged, which can cause
                                symptoms.
                            </p>
                            <div className="row">
                                <div className="col-12 textCenter">
                                    <img src={require("../../img/Disease/Piles/1.png")} alt="Piles" />
                                </div>
                            </div>
                            <p>
                                <b>Symptoms</b>
                            </p>
                            <p>
                                A hard, possibly painful lump may be felt around the anus. It may
                                contain coagulated blood. Piles that contain blood are called
                                thrombosed external hemorrhoids.
                            </p>
                            <p>
                                After passing a stool, a person with piles may experience the
                                feeling that the bowels are still full.
                            </p>
                            <p>Bright red blood is visible after a bowel movement.</p>
                            <p>The area around the anus is itchy, red, and sore.</p>
                            <p>Pain occurs during the passing of a stool.</p>
                            <p>
                                <b>Piles can escalate into a more severe condition. This can include:</b>
                            </p>
                            <p>excessive anal bleeding, also possibly leading to <a className='links' href='https://www.medicalnewstoday.com/articles/158800'>anemia</a></p>
                            <p>infection</p>
                            <p>fecal <a href='https://www.medicalnewstoday.com/articles/165408' className='links'>incontinence</a>, or an inability to control bowel movements</p>
                            <p>
                                anal fistula, in which a new channel is created between the surface
                                of the skin near the anus and the inside of the anus
                            </p>
                            <p>
                                a strangulated hemorrhoid, in which the blood supply to the
                                hemorrhoid is cut off, causing complications including infection or
                                a blood clot
                            </p>
                            <p>
                                Grade IV: These cannot be pushed back in and need treatment. They
                                are large and remain outside of the anus.
                            </p>
                            <a className="links" href="https://en.wikipedia.org/wiki/Hemorrhoid">
                                For More Details
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default Piles;